


























import { Component, Vue, Prop } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";
import { CreateElement } from "vue";
// Import cProd messages
import CProdAutoExpireMsg from "@/components/app/global/contractProducts/cProdAutoExpireMsg.vue";
import CProdCancellationRequest from "@/components/app/global/contractProducts/cProdCancellationRequest.vue";
import CProdUnpaidInvoicesMsg from "@/components/app/global/contractProducts/cProdUnpaidInvoicesMsg.vue";
import CProdUnresolvedProvisionRequestsMsg from "@/components/app/global/contractProducts/cProdUnresolvedProvisionRequestsMsg.vue";

@Component({
  components: {
    "cprod-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvider.vue"),
    "cprod-prov-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvProvider.vue"),
    "cprod-header": () =>
      import(`@/components/app/global/client/contractProducts/cProdHeader.vue`)
  }
})
export default class AdminClientContractProduct extends Vue {
  // Props

  @Prop({ default: () => [] })
  public routes!: (vm: AdminClientContractProduct & any) => any[];

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  @Prop({ required: true })
  public contractId!: IContract["id"];

  // Computed

  /**
   * @name cProdMessages
   * @desc Here we render contract product messages using a render function,
   * otherwise we get unwanted whitespace which breaks the CSS :empty selector
   */

  public get cProdMessages() {
    return {
      render: (h: CreateElement) =>
        h("u-messages", {}, [
          h(CProdCancellationRequest),
          h(CProdUnresolvedProvisionRequestsMsg),
          h(CProdUnpaidInvoicesMsg),
          h(CProdAutoExpireMsg)
        ])
    };
  }

  public get cProdIds() {
    return {
      contractId: this.contractId,
      productId: this.productId
    };
  }
}
